import React from "react";
import { Quote } from "lucide-react";

const ITEMS = [
  {
    id: "ananya",
    quote:
      "Our walnut kitchen looks exactly like the one we built on the website. Honestly better in person.",
    name: "Ananya",
    place: "3BHK · Gokul Road, Hubballi",
  },
  {
    id: "vikram",
    quote:
      "Delivered our home on time, no surprises at handover. Their factory-first approach really shows.",
    name: "Vikram",
    place: "Villa · Vidyagiri, Dharwad",
  },
  {
    id: "priya",
    quote:
      "I changed my wardrobe finish six times before booking. The team was patient and helped me land on Beige Luxury.",
    name: "Priya",
    place: "2BHK · Navanagar, Hubballi",
  },
];

const Testimonials = () => (
  <section
    id="testimonials"
    className="relative bg-[#0A0A0A] text-[#F7F5F0]"
    data-testid="testimonials-section"
  >
    <div className="mx-auto max-w-[1400px] px-6 py-20 md:px-12 md:py-32">
      <div className="grid items-end gap-6 md:grid-cols-12">
        <div className="md:col-span-8">
          <span className="text-[10px] uppercase tracking-[0.32em] text-[#B8996F]">06 · Testimonials</span>
          <h2 className="mt-4 font-[Cormorant_Garamond] text-4xl font-light leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl">
            Heard from<br /> our <span className="italic text-[#B8996F]">residents.</span>
          </h2>
        </div>
      </div>

      <div className="mt-14 grid grid-cols-1 gap-10 md:grid-cols-3 md:gap-14">
        {ITEMS.map((t) => (
          <figure
            key={t.id}
            data-testid={`testimonial-${t.id}`}
            className="relative flex h-full flex-col gap-6 border-l border-[#B8996F]/40 pl-6"
          >
            <Quote className="text-[#B8996F]" size={24} strokeWidth={1.4} />
            <blockquote className="font-[Cormorant_Garamond] text-2xl font-light leading-snug text-white/90">
              “{t.quote}”
            </blockquote>
            <figcaption className="mt-auto">
              <div className="font-[Outfit] text-sm text-white">{t.name}</div>
              <div className="text-[10px] uppercase tracking-[0.24em] text-white/55">{t.place}</div>
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
